import React from "react";
import rosette from "../../assets/images/rosette.png";

const PMSColor = ({ randomColors, colorChange, colorPickerSelectedColor }) => {
  return (
    <div className="p-6 max-w-4xl m-4 border border-gray bg-gradient-to-r from-purple-50 to-blue-50 rounded-lg shadow-md">
      <div className="flex items-center gap-2 mb-6 bg-white/50 rounded-lg p-2">
        <h2 className="text-lg font-semibold text-gray-800">
          PRIMARY COLOR CHOICE
        </h2>
      </div>
      <div
        className={`grid grid-cols-5 gap-4 h-48 ps-[0.9rem] pe-[0.8rem] overflow-y-auto overflow-x-hidden custom-scrollbar`}
      >
        {randomColors.map((color, index) => (
          <div
            key={index}
            className={`
              flex flex-col items-center px-2 pb-2 
              rounded-lg transition-all duration-300
              ${
                colorPickerSelectedColor === color.name
                  ? "bg-[#aaa9a7]"
                  : "hover:bg-purple-100"
              }
            `}
            onClick={() => colorChange(color.value, color.name)}
          >
            <div
              className={`
                relative w-10 h-10 overflow-hidden 
                group cursor-pointer border-2 border-white 
                shadow-md transition-transform duration-300
              `}
              style={{
                backgroundImage: `url(${color.icon})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            ></div>
            <span
              className="text-[0.65rem] text-center text-gray-500 mt-1"
              style={{ lineHeight: "0.8rem" }}
            >
              {color.name}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PMSColor;
